import { useIntl } from '@leagueplatform/locales';
import {
  LANG_ENGLISH,
  LANG_SPANISH,
  LANG_TAGALOG,
  LANG_VIETNAMESE,
  LANG_CHINESE,
  LANG_RUSSIAN,
} from '../constants/lob-and-language';

export const useLocale = () => {
  const { locale } = useIntl();

  const getLocaleLanguage = () => {
    if (locale.startsWith('en')) return LANG_ENGLISH;
    if (locale.startsWith('es')) return LANG_SPANISH;
    if (locale.startsWith('tl') || locale.startsWith('fil'))
      return LANG_TAGALOG;
    if (locale.startsWith('vi')) return LANG_VIETNAMESE;
    if (locale.startsWith('zh')) return LANG_CHINESE;
    if (locale.startsWith('ru')) return LANG_RUSSIAN;
    return LANG_ENGLISH;
  };

  return {
    language: getLocaleLanguage(),
    locale,
  };
};
